/**
 * Converts a string to title case.
 * @param {string} str - The string to convert to title case.
 * @returns {string} The string in title case.
 */
export const toTitleCase = (str) => {
  return str.replace(/_/g, " ").replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

/**
 * Extracts distinct values of a specified attribute from a given trails data set.
 *
 * @param {Object} trailsData - The trails data object containing features.
 * @param {string} attribute - The attribute to extract distinct values from.
 * @returns {Array} An array of distinct values for the specified attribute.
 */
export const getDistinctValues = (trailsData, attribute) => {
  return [
    ...new Set(
      trailsData.features
        .map((item) => item.attributes[attribute])
        .filter((value) => value !== null && value !== undefined)
    ),
  ];
};

/**
 * Fetches data from the given URL and returns the JSON response.
 *
 * @param {string} url - The URL to fetch data from.
 * @returns {Promise<Object>} A promise that resolves to the JSON response.
 * @throws {Error} Throws an error if the response is not ok.
 */
export const fetchFromUrl = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const json = await response.json();
    return json;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

/**
 * Normalizes the state data by renaming the "Trail_Name" attribute to "segment_name" for each trail.
 *
 * @param {Array} trails - An array of trail objects to be normalized.
 * @returns {Array} The normalized array of trail objects.
 */
export const normalizeStateData = (trails) => {
  trails.map((trail) => {
    trail.attributes["segment_name"] = trail.attributes["Trail_Name"];
    trail.attributes["objectid"] = trail.attributes["OBJECTID"];
    trail.attributes["difficulty"] = trail.attributes["Difficulty"];
    trail.attributes["miles"] = trail.attributes["Miles"];
    trail.attributes["surface"] = trail.attributes["Surfacing"];
    trail.attributes.segment_name = toTitleCase(trail.attributes.segment_name);
    delete trail.attributes["Trail_Name"];
    delete trail.attributes["OBJECTID"];
    delete trail.attributes["Difficulty"];
    delete trail.attributes["Miles"];
    delete trail.attributes["Surfacing"];
    return trail;
  });
};

export const isMobileWeb = () => {
  if (typeof window === "undefined") {
    return false;
  } else {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|iphone|ipad|ipod/i.test(userAgent);
  }
};
